var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-2", attrs: { fluid: "" } },
    _vm._l(_vm.section.fields, function (field, fieldKey) {
      return _c(
        "v-card",
        { key: fieldKey, staticClass: "mb-3", attrs: { outlined: "" } },
        [
          _c(
            "v-card-text",
            { staticClass: "py-2 px-3" },
            [
              _c(
                "v-container",
                { staticClass: "pa-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center" } },
                    [
                      !field.isCustom && !field.isComposite
                        ? _c(
                            "v-col",
                            {
                              staticClass: "pr-md-2",
                              attrs: { cols: "12", md: "4" },
                            },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.sortModels(_vm.models),
                                  placeholder: "Model",
                                  clearable: "",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "",
                                },
                                on: {
                                  change: function ($event) {
                                    field.fieldName = ""
                                    _vm.selectModel(field.modelName)
                                  },
                                },
                                model: {
                                  value: field.modelName,
                                  callback: function ($$v) {
                                    _vm.$set(field, "modelName", $$v)
                                  },
                                  expression: "field.modelName",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !field.isCustom &&
                      (!field.isComposite || field.isAssociation)
                        ? _c(
                            "v-col",
                            {
                              staticClass: "pr-md-2",
                              attrs: { cols: "12", md: "4" },
                            },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: field.isAssociation
                                    ? [
                                        ...(_vm.sortColumns(field.modelName) ||
                                          []),
                                        "all",
                                      ]
                                    : _vm.sortColumns(field.modelName),
                                  placeholder: "Column",
                                  clearable: "",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "",
                                },
                                on: {
                                  change: function ($event) {
                                    field.displayType = "default"
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    field.isAssociation
                                      ? {
                                          key: "item",
                                          fn: function ({ item }) {
                                            return [
                                              item === "all"
                                                ? _c("span", [
                                                    _vm._v(
                                                      "Whole model (works only with custom component)"
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(_vm._s(item)),
                                                  ]),
                                            ]
                                          },
                                        }
                                      : null,
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: field.fieldName,
                                  callback: function ($$v) {
                                    _vm.$set(field, "fieldName", $$v)
                                  },
                                  expression: "field.fieldName",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "d-flex justify-end align-center" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", small: "", title: "Move up" },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.moveField("up", fieldKey)
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("arrow_upward")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                title: "Move down",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.moveField("down", fieldKey)
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("arrow_downward")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ies-coral--text",
                              attrs: { icon: "", small: "", title: "Delete" },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.deleteField(fieldKey)
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("delete")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "", text: "" },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleFieldExpanded(fieldKey)
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.expandedFields[fieldKey]
                                      ? "expand_less"
                                      : "expand_more"
                                  )
                                ),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.expandedFields[fieldKey]
                                      ? "Collapse"
                                      : "Expand"
                                  ) +
                                  "\n                        "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-expand-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expandedFields[fieldKey],
                    expression: "expandedFields[fieldKey]",
                  },
                ],
              },
              [
                _c("v-divider"),
                _vm._v(" "),
                _c(
                  "v-card-text",
                  [
                    _c(
                      "v-container",
                      { attrs: { fluid: "" } },
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "mb-3",
                                attrs: { cols: "12", md: "5" },
                              },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "4" } },
                                      [_c("label", [_vm._v("Display Name")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "8" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                          },
                                          model: {
                                            value: field.displayName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                field,
                                                "displayName",
                                                $$v
                                              )
                                            },
                                            expression: "field.displayName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              {
                                staticClass: "mb-3",
                                attrs: { cols: "12", md: "5" },
                              },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "4" } },
                                      [
                                        _c("label", [
                                          _vm._v("Alias Field Name"),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", sm: "8" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                          },
                                          model: {
                                            value: field.alias,
                                            callback: function ($$v) {
                                              _vm.$set(field, "alias", $$v)
                                            },
                                            expression: "field.alias",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            (field.fieldName &&
                              field.fieldName != "" &&
                              !field.isCustom) ||
                            (field.models && field.models.length > 0) ||
                            field.isAssociation ||
                            field.isComposite
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { cols: "12", md: "5" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [
                                            _c("label", [
                                              _vm._v("Display Type"),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                items:
                                                  _vm.allDisplayTypes(field),
                                                "item-text": "name",
                                                "item-value": "value",
                                                outlined: "",
                                                dense: "",
                                              },
                                              model: {
                                                value: field.displayType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "displayType",
                                                    $$v
                                                  )
                                                },
                                                expression: "field.displayType",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.design.page_mode == "2"
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { cols: "12", md: "5" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [_c("label", [_vm._v("Field Width")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                                type: "number",
                                                min: "1",
                                                max: "12",
                                                placeholder: "12",
                                              },
                                              model: {
                                                value: field.fieldWidth,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "fieldWidth",
                                                    $$v
                                                  )
                                                },
                                                expression: "field.fieldWidth",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            [
                              "custom",
                              "text",
                              "password",
                              "integer",
                              "email",
                              "tinymce",
                              "htmlinput",
                            ].includes(field.displayType)
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-3 designer-switch",
                                    attrs: { cols: "12", md: "3" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [_c("label", [_vm._v("Required?")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-switch", {
                                              attrs: { light: "" },
                                              model: {
                                                value: field.required,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "required",
                                                    $$v
                                                  )
                                                },
                                                expression: "field.required",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            [
                              "text",
                              "password",
                              "integer",
                              "email",
                              "textarea",
                              "htmlinput",
                            ].includes(field.displayType)
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-3 designer-switch",
                                    attrs: { cols: "12", md: "3" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [_c("label", [_vm._v("Disabled?")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-switch", {
                                              attrs: {
                                                color: "red",
                                                light: "",
                                              },
                                              model: {
                                                value: field.disabled,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "disabled",
                                                    $$v
                                                  )
                                                },
                                                expression: "field.disabled",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.design.page_mode == "2"
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [_c("label", [_vm._v("Pre-Notice")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value: field.introduction,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "introduction",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "field.introduction",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.design.page_mode == 2
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [_c("label", [_vm._v("Information")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value: field.information,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "information",
                                                    $$v
                                                  )
                                                },
                                                expression: "field.information",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.design.page_mode == 2
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [_c("label", [_vm._v("Warning")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value: field.warning,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "warning",
                                                    $$v
                                                  )
                                                },
                                                expression: "field.warning",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.design.page_mode == 2
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [_c("label", [_vm._v("Post-Notice")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value: field.outroduction,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "outroduction",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "field.outroduction",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { staticClass: "mb-3", attrs: { cols: "12" } },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12", md: "2" } },
                                      [_c("label", [_vm._v("Validation")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12" } },
                                      _vm._l(
                                        field.validation,
                                        function (validation, ruleIndex) {
                                          return _c(
                                            "v-row",
                                            {
                                              key: ruleIndex,
                                              staticClass: "mb-1",
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "3",
                                                  },
                                                },
                                                [
                                                  _c("v-select", {
                                                    attrs: {
                                                      items: [
                                                        {
                                                          text: "Please Select Type",
                                                          value: "",
                                                        },
                                                        {
                                                          text: "Minimum Length",
                                                          value: "minLength",
                                                        },
                                                        {
                                                          text: "Maximum Length",
                                                          value: "maxLength",
                                                        },
                                                        {
                                                          text: "Minimum Value",
                                                          value: "minValue",
                                                        },
                                                        {
                                                          text: "Maximum Value",
                                                          value: "maxValue",
                                                        },
                                                        {
                                                          text: "Not Empty",
                                                          value: "notEmpty",
                                                        },
                                                        {
                                                          text: "Regular Expression",
                                                          value: "regEx",
                                                        },
                                                        {
                                                          text: "Newsletter Subscriptions",
                                                          value:
                                                            "newsletterSubscriptions",
                                                        },
                                                        {
                                                          text: "Date",
                                                          value: "date",
                                                        },
                                                      ],
                                                      label: "Rule Type",
                                                      outlined: "",
                                                      dense: "",
                                                    },
                                                    model: {
                                                      value:
                                                        validation.ruleType,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          validation,
                                                          "ruleType",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "validation.ruleType",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "3",
                                                  },
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      outlined: "",
                                                      dense: "",
                                                      "hide-details": "",
                                                      label:
                                                        "Value (where applicable)",
                                                    },
                                                    model: {
                                                      value: validation.value,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          validation,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "validation.value",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "1",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.removeValidation(
                                                            fieldKey,
                                                            ruleIndex
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("- Remove")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.addValidation(
                                                  fieldKey
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("+ Add Rule")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            (field.fieldName &&
                              field.fieldName != "" &&
                              !field.isCustom) ||
                            (field.models && field.models.length > 0) ||
                            field.isAssociation ||
                            field.isComposite
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [_c("label", [_vm._v("Aggregation")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                items: [
                                                  {
                                                    text: "None - use Raw Value",
                                                    value: "",
                                                  },
                                                  {
                                                    text: "Average",
                                                    value: "AVG",
                                                  },
                                                  {
                                                    text: "Count",
                                                    value: "COUNT",
                                                  },
                                                  { text: "Max", value: "MAX" },
                                                  { text: "Min", value: "MIN" },
                                                  { text: "Sum", value: "SUM" },
                                                  {
                                                    text: "Year",
                                                    value: "YEAR",
                                                  },
                                                ],
                                                outlined: "",
                                                dense: "",
                                              },
                                              model: {
                                                value: field.aggregation,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "aggregation",
                                                    $$v
                                                  )
                                                },
                                                expression: "field.aggregation",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            field.displayType && field.displayType == "custom"
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [
                                            _c("label", [
                                              _vm._v("Custom Component"),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value: field.customComponent,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "customComponent",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "field.customComponent",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            field.isComposite
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [_c("label", [_vm._v("Model A")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                items: _vm.sortModels(
                                                  _vm.models
                                                ),
                                                placeholder:
                                                  "Please Select Model A",
                                                clearable: "",
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  field.fieldNameA = ""
                                                  _vm.selectModel(
                                                    field.modelNameA
                                                  )
                                                },
                                              },
                                              model: {
                                                value: field.modelNameA,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "modelNameA",
                                                    $$v
                                                  )
                                                },
                                                expression: "field.modelNameA",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [_c("label", [_vm._v("Column A")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                items: _vm.sortColumns(
                                                  field.modelNameA
                                                ),
                                                placeholder:
                                                  "Please Select Column A",
                                                clearable: "",
                                                outlined: "",
                                                dense: "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  field.displayType = "default"
                                                },
                                              },
                                              model: {
                                                value: field.fieldNameA,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "fieldNameA",
                                                    $$v
                                                  )
                                                },
                                                expression: "field.fieldNameA",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-row",
                                      { staticClass: "mt-2" },
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [_c("label", [_vm._v("Model B")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                items: _vm.sortModels(
                                                  _vm.models
                                                ),
                                                placeholder:
                                                  "Please Select Model B",
                                                clearable: "",
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  field.fieldNameB = ""
                                                  _vm.selectModel(
                                                    field.modelNameB
                                                  )
                                                },
                                              },
                                              model: {
                                                value: field.modelNameB,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "modelNameB",
                                                    $$v
                                                  )
                                                },
                                                expression: "field.modelNameB",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "4" } },
                                          [_c("label", [_vm._v("Column B")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12", sm: "8" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                items: _vm.sortColumns(
                                                  field.modelNameB
                                                ),
                                                placeholder:
                                                  "Please Select Column B",
                                                clearable: "",
                                                outlined: "",
                                                dense: "",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  field.displayType = "default"
                                                },
                                              },
                                              model: {
                                                value: field.fieldNameB,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "fieldNameB",
                                                    $$v
                                                  )
                                                },
                                                expression: "field.fieldNameB",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showAdditionalRelationships(field)
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-col", { attrs: { cols: "12" } }, [
                                          _c("strong", [
                                            _vm._v(
                                              "Enter relationships between primary model and the model that you want to display in this field."
                                            ),
                                          ]),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      field.fieldRelationships,
                                      function (relation, index) {
                                        return _c(
                                          "v-row",
                                          { key: index, staticClass: "mb-1" },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                attrs: { cols: "12", sm: "4" },
                                              },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    items: _vm.modelFieldNames,
                                                    label: "Model-field A",
                                                    "item-value": "value",
                                                    outlined: "",
                                                    dense: "",
                                                  },
                                                  model: {
                                                    value: relation.modelFieldA,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        relation,
                                                        "modelFieldA",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "relation.modelFieldA",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              {
                                                attrs: { cols: "12", sm: "2" },
                                              },
                                              [
                                                _c("v-select", {
                                                  attrs: {
                                                    items: _vm.joinTypes,
                                                    label: "Join Type",
                                                    "item-value": "value",
                                                    outlined: "",
                                                    dense: "",
                                                  },
                                                  model: {
                                                    value: relation.joinType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        relation,
                                                        "joinType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "relation.joinType",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              {
                                                attrs: { cols: "12", sm: "4" },
                                              },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    items: _vm.modelFieldNames,
                                                    label: "Model-field B",
                                                    "item-value": "value",
                                                    outlined: "",
                                                    dense: "",
                                                  },
                                                  model: {
                                                    value: relation.modelFieldB,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        relation,
                                                        "modelFieldB",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "relation.modelFieldB",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mt-2",
                                                attrs: { cols: "12", sm: "1" },
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removeRelationship(
                                                          fieldKey,
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("delete"),
                                                    ]),
                                                    _vm._v(" Remove"),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addRelationship(
                                                      fieldKey
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("v-icon", [_vm._v("add")]),
                                                _vm._v(" Add Relationship"),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-actions",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              disabled:
                                                _vm.getFieldRelationshipsLength(
                                                  fieldKey
                                                ) == 0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeAllRelationships(
                                                  fieldKey
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("v-icon", [_vm._v("cancel")]),
                                            _vm._v(" Remove Relationships"),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }